document.addEventListener("DOMContentLoaded", function () {

  const grid = document.querySelector("#custom-product-grid");
  const pagination = document.querySelector("#custom-pagination");

  if (!grid) return;

  const productsPerPage = Number(grid.dataset.productsPerPage);
  const url = grid.dataset.productsUrl;

  let products = [];
  let currentPage = 1;


fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error("Collection JSON not found");
    }
    return response.json();
  })
  .then(data => {

    console.log("Collection data:", data);

    if (!data.products) {
      console.error("No products found in response");
      return;
    }

    products = data.products;

    // Available products first
    products.sort((a, b) => {
      return (b.available ? 1 : 0) - (a.available ? 1 : 0);
    });

    renderProducts();
    renderPagination();

  })
  .catch(error => {
    console.error(error);
  });



  function renderProducts(){

    grid.innerHTML = "";

    let start = (currentPage - 1) * productsPerPage;
    let end = start + productsPerPage;

    let pageProducts = products.slice(start,end);


    pageProducts.forEach(product => {

      let html = `
        <div class="product-item">
          <a href="/products/${product.handle}">
            <img src="${product.images[0]?.src || ''}">
            <h3>${product.title}</h3>
          </a>
        </div>
      `;

      grid.insertAdjacentHTML("beforeend",html);

    });

  }


  function renderPagination(){

    pagination.innerHTML="";

    let pages = Math.ceil(products.length / productsPerPage);


    for(let i=1;i<=pages;i++){

      let button=document.createElement("button");

      button.innerHTML=i;

      button.onclick=function(){

        currentPage=i;
        renderProducts();

      };


      pagination.appendChild(button);

    }

  }


});
